import React from 'react';
import Typo from '../typo';
import Media from '../media';
import Button from '../button';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import config from 'utils/config'; // Import the config
import { IMG_BASE_PATH } from 'utils/constants';
import { handleNavigation, isWebView } from 'utils/commonFunctions';

const GamesCard = () => {
  return (
    <>
      <Swiper
        pagination={true}
        modules={[Pagination]}
        // spaceBetween={16} // Optional: adds space between slides
        slidesPerView={2.3} // Adjust based on the number of slides to show at once
      >
        {config.otherGameCards.map((item, index) => (
          <SwiperSlide
            key={index}
            onClick={() => {
              handleNavigation(item.url);
            }}
          >
            <div className={`si-gamesCard ${item.gameCardType ? `si--${item.gameCardType}` : ''}`}>
              <Typo
                transKey={'play_other_games_title'}
                component='h6'
                className='si-gamesCard__title'
              >
              </Typo>
              <Typo
                transKey={'play_other_games_sub_title'}
                component='p'
                className='si-gamesCard__subTitle'
              >
              </Typo>
              {/* <div className='si-gamesCard__thumbs'>
                <Media
                  imgSrc={`${IMG_BASE_PATH}images/${item.imageSrc}.png`}
                  imgAlt={item.imageSrc}
                />
              </div> */}
              <div className='si-gamesCard__cta'>
                <Button transKey={'play_other_games_sub_cta_text'} variant={'secondary'}>
                </Button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default GamesCard;
